export default __webpack_public_path__ + "static/media/assign_record.cc2671b5.svg";